import {createContext} from 'react';

import {TConditionUploadContext} from './types/TConditionUploadContext';

export const ConditionUploadContext = createContext<TConditionUploadContext>(
  {} as TConditionUploadContext
);
